import { themeVars } from '@genie-fintech/ui/style/theme'
import { markedDefaultKey } from '@genie-fintech/ui/style/theme/colors/functions'

const Asterisk = () => (
  <span style={{ color: themeVars.colors.danger[markedDefaultKey] }}>*</span>
)

export default Asterisk
